import {EmulatorMessage} from '../../../../../shared/models/emulator';
import {OneApiTranslatorInbound} from './one-api-translator';
import {YagaTranslatorInbound} from './yaga-translator';

export const isTranslate = (
    emulatorMessage: EmulatorMessage
): EmulatorMessage => {
    switch (emulatorMessage['channelId']) {
        case 8:
            return OneApiTranslatorInbound.eventDelegator(emulatorMessage);
        case 12:
            return YagaTranslatorInbound.messagePayload(emulatorMessage);
        case 6:
        case 7:
            return text(emulatorMessage, emulatorMessage.message);
        default:
            return text(emulatorMessage, 'Channel not supported for preview');
    }
};

const text = (emulatorMessage: EmulatorMessage, message: string): EmulatorMessage => {
    emulatorMessage.mediaMetaData = {
        src: '',
        bubbleType: 'text',
        content: message,
    };
    return emulatorMessage;
};
